module.exports = __webpack_public_path__ + "img/sala_vidro.42135698.png";